import { axiosInstance } from ".";

export const getBuyerStats = async (token) => {
  try {
    const result = await axiosInstance.get("admin/customer/dashboard");

    return result.data.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchAllBuyers = async (token) => {
  try {
    const result = await axiosInstance.get("admin/feature/get/buyers/list");

    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const searchBuyer = async (token, data) => {
  try {
    const result = await axiosInstance.post("admin/checkout/get/buyer/detail", data);

    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchBuyerDetails = async (token, id) => {
  try {
    const result = await axiosInstance.get(`admin/buyer/details/${id}`);

    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
